import React, { useState, useEffect } from 'react';
import { Modal, Button, Form } from "react-bootstrap";
import { BASE_URL } from "../../../constants";
import axios from 'axios';

//const DiscountModal = ({ show, handleClose, handleSave }) => {
const EditAllotParkModal = ({ show, handleClose, onRowSelect }) => {

  const [searchResults, setSearchResults] = useState([]);
  const [searchBdgtName, setSearchBdgtName] = useState();

  useEffect(() => {
    
    const fetchLists = async () => {
      try {

//        const response = await axios.get(`${BASE_URL}/api/get_account_edit`);
        const response = await axios.get(`${BASE_URL}/api/get_budget_edit`, {params: {p_BdgtName : ''}});

        setSearchResults(response.data);


      } catch (err) {
        console.error("Populate error:", err);
      }
    };

    fetchLists();

  }, []);

  // const handleRowClick = async (rowData) => {
  // };

  const handleSearch = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/get_budget_edit`, {params: {p_BdgtName : searchBdgtName}});

      setSearchResults(response.data);

    } catch (error) {
      console.error('Search failed:', error);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg" centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Select Budget Master</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <Form className="mb-3 d-flex gap-3">
          <Form.Group>
            <Form.Label>Budget Name</Form.Label>
            <Form.Control type="text" name="searchBdgtName" value={searchBdgtName}
              onChange={(e) => setSearchBdgtName(e.target.value)} style={{ minWidth: '350px' }}
            />
          </Form.Group>

          <div className="align-self-end">
            <Button variant="primary" onClick={handleSearch}>Search</Button>
          </div>
        </Form>

        {/* <Table bordered hover responsive> */}
        <div style={{ minHeight: '430px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table-modal scty-custom-table">
            <thead>
              <tr>
                <th style={{ width: '60%', textAlign: 'left' }}>Budget Name</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Active</th>
              </tr>
            </thead>
            <tbody>
              {searchResults.length === 0 ? (
                <tr><td colSpan="3" className="text-center">No data</td></tr>
              ) : (
                searchResults.map((row, index) => (
                  <tr key={index} onClick={() => onRowSelect(row)} style={{ cursor: 'pointer' }}>
                    <td style={{ textAlign: 'left' }}>{row.bgt_name}</td>
                    <td style={{ textAlign: 'left' }}>{row.active}</td>
                  </tr>
                ))
              )}
            </tbody>
            {/* </Table> */}
          </table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditAllotParkModal;
